import { useCallback } from 'react';

interface UseGeolocationOptions {
  onLocation: (longitude: number, latitude: number) => void;
  onPermissionDenied: () => void;
}

export function useGeolocation({ onLocation, onPermissionDenied }: UseGeolocationOptions) {
  const onSuccess = useCallback(
    (position: GeolocationPosition) => {
      onLocation(position.coords.longitude, position.coords.latitude);
    },
    [onLocation]
  );

  const onError = useCallback(
    (error: GeolocationPositionError) => {
      console.log(error.message);

      if (error.PERMISSION_DENIED) {
        onPermissionDenied();
      }
    },
    [onPermissionDenied]
  );

  const requestLocation = useCallback(() => {
    if (window.cordova) {
      navigator.geolocation.getCurrentPosition(onSuccess, onError);
    } else {
      navigator.geolocation.getCurrentPosition(function (position) {
        onLocation(position.coords.longitude, position.coords.latitude);
      }, onError);
    }
  }, [onSuccess, onError, onLocation]);

  return { requestLocation };
}
